module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Bicocca_IndBlue_White.6a8cb217.png";